class Exporter {
  dataToCSV ({ values = false, download = true, name = 'my_data.csv', delimiter = ',', newline = '\n' }) {
    if (!values) {
      console.warn('dataToCSV exporter needs values')
      return
    }

    let csvContent = ''
    for (let i = 0; i < values.length; i++) {
      csvContent += values[i].join(delimiter)
      csvContent += i === values.length - 1 ? '' : newline
    }

    if (download) {
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
      let link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.target = '_blank'
      link.download = name
      document.body.appendChild(link) // Required for FF
      link.click()
      document.body.removeChild(link)
    }

    return csvContent
  }
}

export default new Exporter()
